import { Action } from '@ngrx/store';
import { AusmitError } from "../../shared/interfaces";
import { CriteriaModel } from "../../shared/interfaces/CriteriaModel";

export enum ActionTypes {
	CUSTMER_DO_LOGIN = 'CUSTMER_DO_LOGIN',
	CUSTOMER_DO_LOGIN_SUCCESS = 'CUSTOMER_DO_LOGIN_SUCCESS',
	CUSTOMER_DO_LOGIN_ERROR = 'CUSTOMER_DO_LOGIN_ERROR',

	CUSTOMER_DO_REGISTER = 'CUSTOMER_DO_REGISTER',
	CUSTOMER_DO_REGISTER_SUCCESS = 'CUSTOMER_DO_REGISTER_SUCCESS',
	CUSTOMER_DO_REGISTER_ERROR = 'CUSTOMER_DO_REGISTER_ERROR',

	SetRequestProcessing = 'SetRequestProcessing',

	ForgotPassword = 'ForgotPassword',
	ForgotPasswordSuccess = 'ForgotPasswordSuccess',
	ForgotPasswordError = 'ForgotPasswordError',

	ResetPassword = 'ResetPassword',
	ResetPasswordSuccess = 'ResetPasswordSuccess',
	ResetPasswordError = 'ResetPasswordError',

	UpdateProfile = 'UpdateProfile',
	UpdateProfileSuccess = 'UpdateProfileSuccess',
	UpdateProfileError = 'UpdateProfileError',

	DeleteAcount = 'DeleteAcount',
	DeleteAcountSuccess = 'DeleteAcountSuccess',
	DeleteAcountError = 'DeleteAcountError',

	WishlistItems = 'WishlistItems',
	WishlistItemsSuccess = 'WishlistItemsSuccess',
	WishlistItemsError = 'UpdateProfileError',
	WishlistItemsReset = 'WishlistItemsReset',

	GetShippingAddress = 'GetShippingAddress',
	GetShippingAddressSuccess = 'GetShippingAddressSuccess',
	GetShippingAddressError = 'GetShippingAddressError',

	CreateVisitor = 'CreateVisitor',
	CreateVisitorSuccess = 'CreateVisitorSuccess',
	CreateVisitorError = 'CreateVisitorError',

	AddItemToWishlist = 'AddItemToWishlist',
	AddItemToWishlistSuccess = 'AddItemToWishlistSuccess',
	AddItemToWishlistError = 'AddItemToWishlistError',

	DeleteItemToWishlist = 'DeleteItemToWishlist',
	DeleteItemToWishlistSuccess = 'DeleteItemToWishlistSuccess',
	DeleteItemToWishlistError = 'DeleteItemToWishlistError',

	CUSTOMER_DO_LOGOUT = 'CUSTOMER_DO_LOGOUT',
	CUSTOMER_DO_LOGOUT_SUCCESS = 'CUSTOMER_DO_LOGOUT_SUCCESS',
	CUSTOMER_DO_LOGOUT_ERROR = 'CUSTOMER_DO_LOGOUT_ERROR',

	ResendOtp = 'ResendOtp',
	ResendOtpSuccess = 'ResendOtpSuccess',
	ResendOtpError = 'ResendOtpError',

	GetCityAndStateFromZipcode = 'GetCityAndStateFromZipcode',
	GetCityAndStateFromZipcodeSuccess = 'GetCityAndStateFromZipcodeSuccess',
	GetCityAndStateFromZipcodeError = 'GetCityAndStateFromZipcodeError',
}

export class SetRequestProcessing implements Action {
	readonly type = ActionTypes.SetRequestProcessing;

	constructor(public payload: { requestProcessing: boolean }) {
	}
}

export class CustomerDoLogin implements Action {
	readonly type = ActionTypes.CUSTMER_DO_LOGIN;

	constructor(public payload: any) {
	}
}

export class CustomerDoLoginSuccess implements Action {
	readonly type = ActionTypes.CUSTOMER_DO_LOGIN_SUCCESS;

	constructor(public payload: any) {
	}
}

export class CustomerDoLoginError implements Action {
	readonly type = ActionTypes.CUSTOMER_DO_LOGIN_ERROR;

	constructor(public payload: AusmitError) {
	}
}

export class CustomerDoRegister implements Action {
	readonly type = ActionTypes.CUSTOMER_DO_REGISTER;

	constructor(public payload: any) {
	}
}

export class CustomerDoRegisterSuccess implements Action {
	readonly type = ActionTypes.CUSTOMER_DO_REGISTER_SUCCESS;

	constructor(public payload: { regPayload: any, regResponse: any }) {
	}
}

export class CustomerDoRegisterError implements Action {
	readonly type = ActionTypes.CUSTOMER_DO_REGISTER_ERROR;

	constructor(public payload: AusmitError) {
	}
}

export class ForgotPassword implements Action {
	readonly type = ActionTypes.ForgotPassword;

	constructor(public payload: { emailId: string }) {
	}
}

export class ForgotPasswordSuccess implements Action {
	readonly type = ActionTypes.ForgotPasswordSuccess;

	constructor(public payload: { response: any, emailId: string }) {
	}
}

export class ForgotPasswordError implements Action {
	readonly type = ActionTypes.ForgotPasswordError;

	constructor(public payload: AusmitError) {
	}
}

export class ResetPassword implements Action {
	readonly type = ActionTypes.ResetPassword;

	constructor(public payload: {
		password: string,
		resetToken: string,
		emailId: string,
	}) {
	}
}

export class ResetPasswordSuccess implements Action {
	readonly type = ActionTypes.ResetPasswordSuccess;

	constructor(public payload: any) {
	}
}

export class ResetPasswordError implements Action {
	readonly type = ActionTypes.ResetPasswordError;

	constructor(public payload: AusmitError) {
	}
}

export class UpdateProfile implements Action {
	readonly type = ActionTypes.UpdateProfile;

	constructor(public payload: Object) {
	}
}

export class UpdateProfileSuccess implements Action {
	readonly type = ActionTypes.UpdateProfileSuccess;

	constructor(public payload: any) {
	}
}

export class UpdateProfileError implements Action {
	readonly type = ActionTypes.UpdateProfileError;

	constructor(public payload: AusmitError) {
	}
}

export class DeleteAcount implements Action {
	readonly type = ActionTypes.DeleteAcount;

	constructor(public payload: any) {
	}
}

export class DeleteAcountSuccess implements Action {
	readonly type = ActionTypes.DeleteAcountSuccess;

	constructor(public payload: any) {
	}
}

export class DeleteAcountError implements Action {
	readonly type = ActionTypes.DeleteAcountError;

	constructor(public payload: AusmitError) {
	}
}

export class WishlistItems implements Action {
	readonly type = ActionTypes.WishlistItems;

	constructor(public payload: any) {
	}
}

export class WishlistItemsSuccess implements Action {
	readonly type = ActionTypes.WishlistItemsSuccess;

	constructor(public payload: any) {
	}
}

export class WishlistItemsError implements Action {
	readonly type = ActionTypes.WishlistItemsError;

	constructor(public payload: AusmitError) {
	}
}

export class WishlistItemsReset implements Action {
	readonly type = ActionTypes.WishlistItemsReset;

	constructor(public payload?: any) {
	}
}

export class GetShippingAddress implements Action {
	readonly type = ActionTypes.GetShippingAddress;

	constructor(public payload: any) {
	}
}

export class GetShippingAddressSuccess implements Action {
	readonly type = ActionTypes.GetShippingAddressSuccess;

	constructor(public payload: any) {
	}
}

export class GetShippingAddressError implements Action {
	readonly type = ActionTypes.GetShippingAddressError;

	constructor(public payload: AusmitError) {
	}
}

export class CreateVisitor implements Action {
	readonly type = ActionTypes.CreateVisitor;

	constructor(public payload: any) {
	}
}

export class CreateVisitorSuccess implements Action {
	readonly type = ActionTypes.CreateVisitorSuccess;

	constructor(public payload: any) {
	}
}

export class CreateVisitorError implements Action {
	readonly type = ActionTypes.CreateVisitorError;

	constructor(public payload: AusmitError) {
	}
}

export class AddItemToWishlist implements Action {
	readonly type = ActionTypes.AddItemToWishlist;

	constructor(public payload: any) {
	}
}

export class AddItemToWishlistSuccess implements Action {
	readonly type = ActionTypes.AddItemToWishlistSuccess;

	constructor(public payload: any) {
	}
}

export class AddItemToWishlistError implements Action {
	readonly type = ActionTypes.AddItemToWishlistError;

	constructor(public payload: AusmitError) {
	}
}

export class DeleteItemToWishlist implements Action {
	readonly type = ActionTypes.DeleteItemToWishlist;

	constructor(public payload: any) {
	}
}

export class DeleteItemToWishlistSuccess implements Action {
	readonly type = ActionTypes.DeleteItemToWishlistSuccess;

	constructor(public payload: any) {
	}
}

export class DeleteItemToWishlistError implements Action {
	readonly type = ActionTypes.DeleteItemToWishlistError;

	constructor(public payload: AusmitError) {
	}
}

export class CUSTOMER_DO_LOGOUT implements Action {
	readonly type = ActionTypes.CUSTOMER_DO_LOGOUT;

	constructor(public payload: any) {
	}
}

export class CUSTOMER_DO_LOGOUT_SUCCESS implements Action {
	readonly type = ActionTypes.CUSTOMER_DO_LOGOUT_SUCCESS;

	constructor(public payload: any) {
	}
}

export class CUSTOMER_DO_LOGOUT_ERROR implements Action {
	readonly type = ActionTypes.CUSTOMER_DO_LOGOUT_ERROR;

	constructor(public payload: AusmitError) {
	}
}

export class ResendOtp implements Action {
	readonly type = ActionTypes.ResendOtp;

	constructor(public payload: any) {
	}
}

export class ResendOtpSuccess implements Action {
	readonly type = ActionTypes.ResendOtpSuccess;

	constructor(public payload: any) {
	}
}

export class ResendOtpError implements Action {
	readonly type = ActionTypes.ResendOtpError;

	constructor(public payload: AusmitError) {
	}
}

export class GetCityAndStateFromZipcode implements Action {
	readonly type = ActionTypes.GetCityAndStateFromZipcode;

	constructor(public payload: any) {
	}
}

export class GetCityAndStateFromZipcodeSuccess implements Action {
	readonly type = ActionTypes.GetCityAndStateFromZipcodeSuccess;

	constructor(public payload: any) {
	}
}

export class GetCityAndStateFromZipcodeError implements Action {
	readonly type = ActionTypes.GetCityAndStateFromZipcodeError;

	constructor(public payload: AusmitError) {
	}
}


export type Actions =
	| SetRequestProcessing
	| CustomerDoLogin
	| CustomerDoLoginSuccess
	| CustomerDoLoginError
	| CustomerDoRegister
	| CustomerDoRegisterSuccess
	| CustomerDoRegisterError
	| ForgotPassword
	| ForgotPasswordSuccess
	| ForgotPasswordError
	| ResetPassword
	| ResetPasswordSuccess
	| ResetPasswordError
	| UpdateProfile
	| UpdateProfileSuccess
	| UpdateProfileError
	| DeleteAcount
	| DeleteAcountSuccess
	| DeleteAcountError
	| WishlistItems
	| WishlistItemsSuccess
	| WishlistItemsError
	| WishlistItemsReset
	| GetShippingAddress
	| GetShippingAddressSuccess
	| GetShippingAddressError
	| CreateVisitor
	| CreateVisitorSuccess
	| CreateVisitorError
	| AddItemToWishlist
	| AddItemToWishlistSuccess
	| AddItemToWishlistError
	| DeleteItemToWishlist
	| DeleteItemToWishlistSuccess
	| DeleteItemToWishlistError
	| CUSTOMER_DO_LOGOUT
	| CUSTOMER_DO_LOGOUT_SUCCESS
	| CUSTOMER_DO_LOGOUT_ERROR
	| ResendOtp
	| ResendOtpSuccess
	| ResendOtpError
	| GetCityAndStateFromZipcode
	| GetCityAndStateFromZipcodeSuccess
	| GetCityAndStateFromZipcodeError;


